import { t } from "i18next";
import { Form, Select } from "antd";

import styles from "./SearchClientEmployee.module.scss";

import useClientEmployees from "@/hooks/useClientEmployees";
import {
  ActionCreatorTypes,
  useCaseFormContext,
} from "@/components/CaseForm/CaseFormContext";

const { Option } = Select;

const SearchClientEmployee = () => {
  const { clientEmployees, getClientEmployeesLoading } = useClientEmployees({});
  const { state, dispatch } = useCaseFormContext();

  const handleSearch = (clientsEmployeeUUID: string, value: string) => {
    const employee = clientEmployees.find(
      (p) => p.clientsEmployeeUUID === clientsEmployeeUUID
    );
    if (employee) {
      if (employee.name.toLowerCase().includes(value.toLowerCase())) {
        return true;
      }
    }
    return false;
  };

  const handleSelect = (value: string) => {
    const clientEmployee = clientEmployees.find(
      (e) => e.clientsEmployeeUUID === value
    );
    if (!clientEmployee) {
      return;
    }
    dispatch({
      type: ActionCreatorTypes.SetClientsEmployee,
      payload: clientEmployee,
    });
  };

  const handleClear = () => {
    dispatch({
      type: ActionCreatorTypes.SetClientsEmployee,
      payload: null,
    });
  };

  return (
    <div className={styles.container}>
      <Form.Item
        className={styles.formItem}
        labelCol={{ span: 6 }}
        label={t("Співробітник контрагента")}
      >
        <Select
          listHeight={1000}
          showSearch
          allowClear
          loading={getClientEmployeesLoading}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option?.value ? handleSearch(option.value as string, input) : false
          }
          value={state.clientsEmployee?.clientsEmployeeUUID || ""}
          onSelect={handleSelect}
          onClear={handleClear}
          onClick={(e) => e.stopPropagation()}
        >
          {clientEmployees.map((employee) => (
            <Option
              key={employee.clientsEmployeeUUID}
              value={employee.clientsEmployeeUUID}
            >
              {employee.name}
            </Option>
          ))}
          {!clientEmployees.find(
            (e) =>
              e.clientsEmployeeUUID ===
              state.clientsEmployee?.clientsEmployeeUUID
          ) &&
            state.clientsEmployee && (
              <Option
                key={state.clientsEmployee.clientsEmployeeUUID}
                value={state.clientsEmployee.clientsEmployeeUUID}
              >
                {state.clientsEmployee.name}
              </Option>
            )}
        </Select>
      </Form.Item>
    </div>
  );
};

export default SearchClientEmployee;
